import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Grid2 as Grid, Container } from '@mui/material';

import { LogoLightIcon, EmployerSend, EmployerJob, EmployerPeople } from '@carcareers/assets';
import { useAuth } from '@carcareers/hooks';
import { useEmployerProfileQuery } from '@carcareers/store';
import { skipToken } from '@reduxjs/toolkit/query';
import { MediaCard, Footer, JobRecents, Intercom } from '@carcareers/components';
import { routes } from '@carcareers/utils';

export const EmployerHome: FC = () => {
  const { session } = useAuth();
  const navigate = useNavigate();
  const { data: employerProfile } = useEmployerProfileQuery(session?.user?.id ?? skipToken);

  return (
    <>
      <Intercom />
      <Container
        maxWidth="xl"
        sx={{ p: { xs: 2, sm: 4, md: 8 }, minHeight: { xs: 'calc(100vh - 160px)', sm: 'calc(100vh - 132px)' } }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, my: 4 }}>
            <Typography variant="h1">Welcome, {employerProfile?.user?.firstName}</Typography>
            <Typography variant="body1" color="text.secondary">
              Manage your job postings, candidates, and account settings from this central location.
            </Typography>
          </Box>
          <Box
            component="img"
            src={LogoLightIcon}
            alt="car careers dot com logo"
            sx={{
              width: 250,
              height: 250,
              zIndex: -1,
            }}
          />
        </Box>
        <JobRecents />
        <Grid container spacing={3} sx={{ mt: 4 }}>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <MediaCard
              src={EmployerJob}
              alt="Post a New Job"
              title="Post a New Job"
              description="Create a new job, and posting all in one place."
              onClick={() => navigate(`/${routes.EMPLOYER_HOME}/${routes.EMPLOYER_JOBS_ADD}`)}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <MediaCard
              src={EmployerSend}
              alt="View your Jobs"
              title="View your Jobs"
              description="View and manage your job postings."
              onClick={() => navigate(`/${routes.EMPLOYER_HOME}/${routes.EMPLOYER_POSTS_INDEX}`)}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <MediaCard
              src={EmployerPeople}
              alt="Manage Candidates"
              title="Manage Candidates"
              description="View and manage your candidates."
              onClick={() => navigate(`/${routes.EMPLOYER_HOME}/${routes.EMPLOYER_CANDIDATES_INDEX}`)}
            />
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </>
  );
};

export default EmployerHome;
